import axios from 'axios';
import {User} from '../User';
import {links} from '../links'

export const getUserInfo = async (id?: string): Promise<User | null> => {
    const userId = id || "self"
    const response = await axios.get(`${links.origin}/apiweb/student/${userId}/info/`);
    return response.data;
}